/**
 * Composable to adjust scroll of a container based on pointer position
 */
export function useScrollFixer() {
  /**
   * The distance in pixels from the top of the dropdown list to the top of the pointer element.
   */
  function pixelsToPointerTop(container, index) {
    let pixels = 0;
    if (container && container.children[index]) {
      for (let i = 0; i < index; i++) {
        pixels += container.children[i].offsetHeight;
      }
    }
    return pixels;
  }

  /**
   * The distance in pixels from the top of the dropdown list to the bottom of the pointer element.
   */
  function pixelsToPointerBottom(container, index) {
    return pixelsToPointerTop(container, index) + pointerHeight(container, index);
  }

  /**
   * The height of the pointer element.
   */
  function pointerHeight(container, index) {
    const el = container?.children[index];
    return el ? el.offsetHeight : 0;
  }

  /**
   * Current viewport bounds (top & bottom) of the container.
   */
  function viewport(container) {
    return {
      bottom: container ? container.scrollTop + container.offsetHeight : 0,
      top: container ? container.scrollTop : 0,
    };
  }

  /**
   * Scroll the container to a specific position.
   */
  function scrollTo(position, container) {
    if (container) container.scrollTop = position;
  }

  /**
   * Adjust scroll so that the pointer element is in view.
   */
  function fixScroll(container, index) {
    const top = pixelsToPointerTop(container, index);
    const bottom = pixelsToPointerBottom(container, index);
    const view = viewport(container);

    if (top <= view.top) {
      scrollTo(top, container);
    } else if (bottom >= view.bottom) {
      scrollTo(view.top + pointerHeight(container, index), container);
    }
  }

  return {
    fixScroll,
    pixelsToPointerBottom,
    pixelsToPointerTop,
    pointerHeight,
    scrollTo,
    viewport,
  };
}
